/**
 * dev-invariants.ts — the shared dev-time "filled-mock law" invariant helper
 * (R4-P2 correctness review N2). Every primitive in this library defined the
 * identical 5-line `assertFilled` function verbatim (17 files) — pure
 * duplication with no spec line requiring each file own its own copy, and a
 * direct violation of CLAUDE.md Constitution clause 4 ("Reuse before
 * extend") / code-quality.md #13 ("2+ features same pattern → extract to
 * `components/shared/` or `lib/`"). Extracted here; primitive-specific
 * composites (`FigureFrame.assertMassRoot`, `MockChart.assertSeries`) stay
 * thin wrappers around this shared function rather than reimplementing it.
 */

/**
 * Dev-only invariant: throws when `condition` is false, a no-op in
 * production builds. Used throughout the R4-P2 primitive library to enforce
 * the FILLED-MOCK LAW (no unboxed wireframes, no empty rectangles, no
 * fake/blank content) at the moment a primitive is composed — a caller
 * finds out immediately in dev, never silently ships an empty figure.
 */
export function assertFilled(condition: boolean, message: string): void {
  if (process.env.NODE_ENV !== 'production' && !condition) {
    throw new Error(message);
  }
}
